<template>
	<c-loader class="c-project-list" v-if="loading" />
	<div class="view-wrapper project" v-else>
		<div class="project__hero" :style="'background-image:url(' + project.featuredImageUrl + ')'"></div>
		<div class="container">
			<h1 v-if="project.title" class="project__title" v-html="project.title"></h1>

			<div class="project__content">
				<div class="project__description" v-html="project.description"></div>
				<c-project-facts :facts="project.facts" />
			</div>

			<div class="project__flex-content">
				<c-flex-content :content="project.flex_content" />
			</div>

			<section class="project__otherprojects" v-if="project.relatedProjects">
				<h3>{{ localizedRelatedProjectsButtonText }}</h3>
				<c-project-list :ids="project.relatedProjects" padded="true"></c-project-list>
			</section>
		</div>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import { getProjectBySlug } from '@/api/projects.wp.api'
import CProjectFacts from '@/components/ProjectFacts'
import CProjectList from '@/components/ProjectList'
import CFlexContent from '@/components/FlexContent'
import CLoader from '@/components/Loader'

export default {
	name: 'project',
	components: {
		CProjectFacts,
		CProjectList,
		CFlexContent,
		CLoader
	},
	data: () => ({
		slug: null,
		projectData: {},
		headData: defaultHeadData,
		loading: true,
		relatedProjectsButtonText: {
			'en-us': 'Related projects',
			'de-ch': 'Weitere Projekte'
		}
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		project() {
			return this.projectData
		},
		localizedRelatedProjectsButtonText() {
			return this.relatedProjectsButtonText[this.settings.currentLang]
		}
	},
	watch: {
		'$route': function() {
			this.slug = this.$store.state.route.params.project
			this.fetchProjectData()
			utils.setHtmlLang(this.settings.currentLang)
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.slug = this.$store.state.route.params.project
		this.fetchProjectData()
	},
	methods: {
		fetchProjectData() {
			getProjectBySlug({ lang: this.settings.currentLang, slug: this.slug }).then((project) => {
				if (project) {
					utils.setHtmlLang(this.settings.currentLang)
					this.projectData = project
					this.$store.dispatch('setAltLanguageLink', { lang: project.lang, link: (project.lang == 'en-us' ? '/en/work/' + project.slug : '/work/' + project.slug)})
					this.$store.dispatch('setAltLanguageLink', { lang: project.alternateLanguage.lang, link: (project.alternateLanguage.lang == 'en-us' ? '/en/work/' + project.alternateLanguage.slug : '/work/' + project.alternateLanguage.slug)})
					this.updateHeadData()
					this.loading = false
				} else {
					this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404')
				}
			}).catch(err => this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404'))
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.project) {
				this.headData = utils.transformHeadData({
					meta: this.project.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}

</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.project {
		padding-bottom: 4rem;

		@include mq($from: medium) {
			margin-bottom: 6rem;
		}

		.c-oembed {
			max-width: none;
		}

		&__hero {
			height: 17rem;
			width: 100%;
			max-width: 1600px;
			background-size: cover;
			background-position: center top;
			background-repeat: no-repeat;
			margin: 0 auto;

			@include mq($from: medium) {
				height: 34rem;
				margin-top: -3rem;
			}
		}
		&__title {
			margin-top: -2rem;
			background-color: $colorBrandSecondary;
			color: #fff;
			padding: .5rem 1.5rem 1rem 1.5rem;
			line-height: 1;
			display: inline-block;
		}
		&__content {
			display: flex;
			flex-wrap: wrap;
			margin-top: 1rem;
			margin-bottom: 2rem;

			@include mq($from: medium) {
				margin-bottom: 4rem;
			}
		}
		&__description {
			width: 100%;
			margin-bottom: 3rem;

			@include mq($from: medium) {
				width: 75%;
				padding-right: 3rem;
				margin-bottom: 0;
			}
		}

		&__images {
			margin-top: 3rem;

			@include mq($from: medium) {
				margin-top: 6rem;
			}
		}
		&__image-wrapper {
			margin: 0;
			margin-top: 2rem;

			figcaption {
				font-size: .8rem;
				color: #888;

				p {
					margin: 0;
				}
			}
		}
		&__image {
			height: auto;
			&--featured {
				width: 100%;
			}
			&--half {
				width: 50%;
			}
			&--full {
				width: 100%;
			}
		}

		.c-project-list {
			margin-top: .5rem;

			@include mq($from: medium) {
				margin-top: 1rem;
			}
		}

		&__otherprojects {
			margin-top: 4rem;
			margin-bottom: -3rem;

			@include mq($from: medium) {
				margin-bottom: -4rem;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// Project.vue?63e9c310